import { render, staticRenderFns } from "./AddNotebookCatalogDialog.vue?vue&type=template&id=3dc68718&"
import script from "./AddNotebookCatalogDialog.vue?vue&type=script&lang=js&"
export * from "./AddNotebookCatalogDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddNotebookCatalogDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports